// Atlas logó — "Constellation Hub" (a design tervből): központi mag (Atlas) + csatlakozó szatellit-
// node-ok (a ráépülő appok) + a kiemelt jobb-felső node = az Odin adat-forrás. Alapból MORGENS brand-zöld.
import { useId } from 'react';

export function AtlasMark({
  size = 26,
  color,
  flat = false,
  radius = 8,
}: {
  size?: number;
  color?: string;
  /** Lap nélküli variáns: nincs háttér-lap, maga a konstelláció rajzolódik az accent-GRADIENSSEL (nem tömör). */
  flat?: boolean;
  radius?: number;
}): JSX.Element {
  // EGYEDI gradient-id példányonként (useId): különben több AtlasMark ugyanazt az id-t definiálná, és a
  // `url(#id)` a DOM-ban ELSŐ (esetleg `display:none` alatti, pl. a rejtett desktop-sidebar) definícióra mutatna —
  // az pedig festéknek nem elérhető → az ikon üresen maradna (ez volt a mobil-drawer flat bug oka).
  const uid = useId().replace(/:/g, '');
  const boxGradId = `atlasMarkBox-${uid}`;
  const flatGradId = `atlasMarkFlat-${uid}`;
  // Lap-fill (nem-flat): a sötét→világos brand accent-gradient (#0c4a42→#38bd6d), a CTA-gombbal egyező.
  const boxFill = color ?? `url(#${boxGradId})`;
  // `flat`: nincs lap; MAGA a konstelláció kapja a zöld gradienst (közepes→világos, mindkét témán látszik).
  const fg = flat ? (color ?? `url(#${flatGradId})`) : '#fff';
  const punch = flat ? 'transparent' : boxFill;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        {/* Accent-gradient a háttér-laphoz (135°, a CTA-gombbal egyező token-értékek). */}
        <linearGradient id={boxGradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--accent-grad-from)" />
          <stop offset="100%" stopColor="var(--accent-grad-to)" />
        </linearGradient>
        {/* Zöld gradient a flat konstellációhoz — KÖZVETLEN HEX (az `rgb(var(--…))` beágyazva egy SVG stop-color
            attribútumba NEM oldódik fel!). Közepes→világos zöld (#229a5a → #86d3b2): mindkét témán jól látszik.
            userSpaceOnUse → a vékony vonalakon is renderelődik. */}
        <linearGradient
          id={flatGradId}
          gradientUnits="userSpaceOnUse"
          x1="5"
          y1="6"
          x2="27"
          y2="26"
        >
          <stop offset="0%" stopColor="#229a5a" />
          <stop offset="100%" stopColor="#86d3b2" />
        </linearGradient>
      </defs>
      {!flat && <rect width="32" height="32" rx={radius} fill={boxFill} />}
      {/* kapcsolat-élek */}
      <g stroke={fg} strokeWidth="1.5" opacity={flat ? 0.85 : 0.6}>
        <line x1="16" y1="16" x2="8.5" y2="8.5" />
        <line x1="16" y1="16" x2="24.5" y2="10.5" />
        <line x1="16" y1="16" x2="11" y2="24.5" />
        <line x1="16" y1="16" x2="23.5" y2="23" />
      </g>
      {/* szatellit-node-ok (csatlakozó appok) */}
      <circle cx="8.5" cy="8.5" r="1.9" fill={fg} />
      <circle cx="11" cy="24.5" r="1.9" fill={fg} />
      <circle cx="23.5" cy="23" r="1.9" fill={fg} />
      {/* Odin adat-forrás (kiemelt) */}
      <circle cx="24.5" cy="10.5" r="2.9" fill={fg} />
      <circle cx="24.5" cy="10.5" r="1.15" fill={punch} />
      {/* mag (Atlas) */}
      <circle cx="16" cy="16" r="3.5" fill={fg} />
    </svg>
  );
}

/** "Atlas" szövegjel — a mark mellé (login, sidebar). */
export function AtlasWordmark({ className }: { className?: string }): JSX.Element {
  return (
    <span
      className={`font-semibold tracking-[-0.015em] ${className ?? 'text-lg'}`}
      aria-label="Atlas"
    >
      Atlas
    </span>
  );
}
